import type { VariationComponent } from "~types/types";
import { filterForStoriesWithAudioImage } from "~utils/filterForStoriesWithAudioImage";
import {
    checkItemArrayIntegrity,
    checkMediaIntegrity,
    type IntegrityStatus,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./SeriesCard";

export default function integrityCheck({
    alternateFirstItems,
}: VariationComponent): IntegrityStatus {
    if (!alternateFirstItems?.length) {
        return ["The LineupContentAudio8Up module has no items"];
    }

    const storiesWithAudio =
        filterForStoriesWithAudioImage(alternateFirstItems);
    const errorMessages = checkItemArrayIntegrity(storiesWithAudio);

    errorMessages.push(
        ...checkMediaIntegrity(storiesWithAudio, MEDIA_PRIORITY)
    );

    return errorMessages;
}
